<template>
  <div class="ui fluid container black hero" id="landing">
    <div class="ui stackable center aligned grid">
      <div class="six wide left aligned middle aligned column">
        <h1 class="ui inverted header">
          Try the Aragon dapp
          <div class="ui hidden half divider"></div>
          <div class="sub header">Create value without borders or intermediaries</div>
        </h1>
        <div class="ui hidden divider"></div>
        <div class="ui hidden divider"></div>
        <a class="ui huge aragon gradient button downloadButton" href="https://github.com/AragonOne/aragon/releases/" target="_blank">Download Aragon Alpha</a>
        <div class="ui hidden divider"></div>
        <span class="white text" id="weburl">or try out the <a href="https://alpha.aragon.one" target="_blank">web version</a></span>
      </div>
      <div class="six wide column">
        <div class="ui container">
          <img class="ui fluid image" src="https://aragon.one/rsc/imgs/screenshot.png" id="screenshot">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'core',
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Core.vue?206236c8